import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {NewsComponent} from "./news.component";
import {RouterModule} from "@angular/router";

@NgModule({
  imports: [
    CommonModule, RouterModule
  ],
  declarations: [NewsComponent],
  exports: [NewsComponent],

})
export class NewsModule { }



// WEBPACK FOOTER //
// ./src/app/components/news/news.module.ts